<template>
	<div :style="{ height: bodyHeight + 'px' }" class="online m-body">
		<van-image
			width="3.34rem"
			height="0.96rem"
			style="display: block;margin: 0.32rem auto 0.24rem;"
			:src="require('@/assets/images/dayu_m_header.png')"
		></van-image>
		
		<dl class="qjc-texta-c">
			<dt>
				<van-image
					width="4.7rem"
					height="4.7rem"
					:src="require('@/assets/images/dayu_m_code.png')"
				></van-image>
			</dt>
			<dd class="qjc-fts-36 qjc-c-fff">识别图中二维码进入在线咨询</dd>
		</dl>
		
	</div>
</template>

<script>
	import Vue from 'vue'
	import { Image } from 'vant'
	Vue.use(Image);
	
	export default{
		name: 'dayuCourse',
		data() {
			return {
				bodyHeight: document.documentElement.clientHeight,
			}
		}
	}
</script>

<style lang="scss" scoped>
	.online{
		color: #5FD6FF;
		padding-top: 0.08rem;
		padding-bottom: 1.9rem;
		
		dl{
			margin-top: 1.2rem;
			
			dd{
				line-height: 0.36rem;
				margin-top: 0.4rem;
			}
		}
	}
</style>
